import { Outlet } from 'react-router-dom';

export function Layout() {
  return (
    <div className="bg-background">
      <Outlet />
    </div>
  );
}